import React, { useEffect } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import LocationGate from "../../lib/LocationGate";

const APP_NAME = "Rescigo Health";

function AppShellInner({ title, subtitle, actions, children }) {
  // Iter 138 — Browser tab title shows "Page name · App name" so users
  // can identify tabs when many are open.
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = `${title} · ${APP_NAME}`;
    return () => { document.title = prev; };
  }, [title]);

  return (
    // Iter 111 — freeze both Sidebar and Topbar by moving page scroll
    // into <main>. Outer container is h-screen + overflow-hidden so the
    // browser scroll never bubbles up past the shell; the shell chrome
    // (sidebar + topbar) sit outside that scroll region and stay pinned.
    <div className="h-screen flex bg-[#F7F6F2] overflow-hidden print:h-auto print:overflow-visible">
      <div className="print:hidden"><Sidebar /></div>
      <div className="flex-1 flex flex-col min-w-0">
        <div className="print:hidden"><Topbar title={title} subtitle={subtitle} actions={actions} /></div>
        <div className="hidden print:block px-6 pt-6">
          <h1 className="font-heading text-3xl">{title}</h1>
          {subtitle && <p className="text-sm text-[#5C5A55] mt-1">{subtitle}</p>}
        </div>
        <main className="flex-1 p-6 sm:p-8 overflow-y-auto print:overflow-visible"
              data-testid="main-content">
          {children}
        </main>
      </div>
    </div>
  );
}

export default function AppShell(props) {
  return (
    <LocationGate
      pingPath="/api/findgps/ping/user"
      tokenKey="rescigo_token"
      bodyShape="universal"
      label="Rescigo"
    >
      <AppShellInner {...props} />
    </LocationGate>
  );
}
